module.exports = __webpack_public_path__ + "static/media/book-dead.0ddef5a8.svg";